export const ROLE_MAP = {
    1: '操作层',
    3: '管理层',
    5: '决策层',
}
